// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"UserInfo_userInfo__2WR9P","userText":"UserInfo_userText__1fA_5"};